





import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataType } from '@/core/data/DataType';
import apexchart from 'vue-apexcharts';
import { FView } from '@/core/FView';
import { VisitorsRecord } from '@/core/data/sets/VisitorsRecord';
import { Common } from '@/core/Common';
import moment from 'moment';
import { WeekRecordGroup } from '@/core/data/sets/computed/WeekRecordGroup';

@Component ({
  components: {
      apexchart
  },
})
export default class extends Vue {
    @Prop({ default: 350 }) height!: number;

    series = this.getSeries();
    chartOptions = {
        title: {
            text: 'Посещения по дням недели',
            align: 'center',
            style: {
                fontSize: '20px',
                fontFamily: 'FSElliotProBold',
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                endingShape: 'rounded',
                columnWidth: '75%',
            },
        },
        dataLabels: { enabled: false },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: Common.GetWeekDaysShort(),
            labels: {
                style: {
                    colors: this.getDayColors(),
                }
            },
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: {
                formatter: (val:any) => {
                    return "Посещений: " + val;
                }
            }
        },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'],
                opacity: 0.5
            },
        },
        legend: {
            itemMargin: {
                vertical: 1
            },
        },
    }

    getDataSet(): WeekRecordGroup[] {
        return WeekRecordGroup.getVisitorsByWeeks();
    }

    getSeries() {
        let series:any = [];
        for (let week of this.getDataSet()) {
            let serie:number[] = [];
            for (let i = 1; i <= 7; i++) {
                let record = week.Records[i];
                if (record != null) {
                    serie.push(record.visitors);
                } else {
                    serie.push(0);
                }
            }
            series.push({
                name: "Неделя " + week.formatDescription(),
                data: serie,
            });
        }
        return series;
    }

    getDayColor(day: number) {
        return Common.IsWeekendDay(day) ? "#C11" : "#111"
    }

    getDayColors() {
        let colors: string[] = [];
        for (let i in Common.GetWeekDaysShort()) {
            colors.push(Common.IsWeekendDay(Number(i) + 1) ? "#C11" : "#111");
        }
        return colors;
    }
}
